import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => `${theme.getValue(8)}px`};
  min-height: ${({ theme }) => `${theme.getValue(80)}px`};
`;

export default { Wrapper };
